<template>
  <div class="question-container">
    <div class="question">
      <div class="label">{{ `${$t(questionLabelI18nKey)}: ` }}</div>
      <div class="content">{{ questionName }}</div>
    </div>
    <!-- 视频 -->
    <template v-if="!hideAnswer && questionType === 'video'">
      <div v-if="hasVideoResourceKey" class="answer">
        <div class="label">{{ `${$t(videoLabelI18nKey)}: ` }}</div>
        <div v-loading="loading" class="content video-container" @click="handleVideoPlayIconClick">
          <img class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')"/>
        </div>
      </div>
      <div v-else class="answer no-video-answer">
        <div class="label">{{ `${$t(answerLabelI18nKey)}: ` }}</div>
        <div class="content">{{ isHr ? $t(`${i18nPrefix}.label.notUploadedByHr`) : $t(`${i18nPrefix}.label.videoNotUploaded`) }}</div>
      </div>
      <div class="remarks">
        <div class="label">{{ `${$t(noteLabelI18nKey)}: ` }}</div>
        <div class="content">{{ answer|formatValue }}</div>
      </div>
    </template>
    <!-- 附件 -->
    <template v-else-if="!hideAnswer && questionType === 'portfolio' && hasVideoResourceKey">
      <div class="answer attachment">
        <div class="label"></div>
        <div class="content">
          <el-button v-loading="loading" class="view-btn" element-loading-spinner="el-icon-loading" type="text" @click="handleViewAttachmentBtnClick">
            {{ $t('common.btn.view') }}
          </el-button>
        </div>
      </div>
      <div class="remarks">
        <div class="label">{{ `${$t(noteLabelI18nKey)}: ` }}</div>
        <div class="content">{{ answer|formatValue }}</div>
      </div>
    </template>
    <template v-else-if="!hideAnswer">
      <div class="answer text">
        <div class="label">{{ `${$t(answerLabelI18nKey)}: ` }}</div>
        <div class="content">{{ answer|formatValue }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    isHr: {
      type: Boolean,
      default: false
    },
    questionName: {
      type: String,
      required: true
    },
    questionType: {
      required: true
    },
    answer: {
      required: true
    },
    videoResourceKey: {
      required: true
    },
    hideAnswer: {
      type: Boolean,
      default: false
    },
    questionLabelI18nKey: {
      default: 'admin.application.candidate.label.questionnaireQuestion'
    },
    answerLabelI18nKey: {
      default: 'admin.application.candidate.label.answer'
    },
    videoLabelI18nKey: {
      default: 'admin.application.candidate.label.video'
    },
    noteLabelI18nKey: {
      default: 'admin.application.candidate.label.note'
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      loading: false
    }
  },
  computed: {
    hasVideoResourceKey () {
      return !_.isEmpty(this.videoResourceKey)
    }
  },
  created () {

  },
  methods: {
    handleVideoPlayIconClick () {
      this.loading = true
      this.$emit('videoPlayIconClick', () => {
        this.loading = false
      })
    },
    handleViewAttachmentBtnClick () {
      this.loading = true
      this.$emit('viewAttachmentBtnClick', () => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  margin-top: 20px;
  padding: 25px 40px;
  border: 1px solid #E4E7ED;
  font-size: 16px;

  .question,
  .answer,
  .remarks {
    display: flex;
    align-items: flex-start;
    line-height: 24px;
    white-space: break-spaces;

    .label {
      width: 84px;
      flex-shrink: 0;
      text-align: right;
    }

    .content {
      flex: 1;
      margin-left: 15px;

      &.video-container {
        flex: initial;
        position: relative;
        width: 164px;
        height: 78px;
        cursor: pointer;
        background-image: url($baseDomain + 'static/image/video/video_bg.png');
        background-size: 100% 100%;

        .video-play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          height: 40px;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .remarks {
    margin-top: 20px;
  }

  .answer {
    margin-top: 20px;

    &.attachment {
      .content {
        .view-btn {
          position: relative;

          ::v-deep .el-loading-mask {
            background-color: rgba(251, 251, 251, .9);

            .el-loading-spinner {
              font-size: 20px;
              margin-top: -10px;
            }
          }
        }
      }
    }
  }
}
</style>
